module.exports = __webpack_public_path__ + "static/media/icon-sound.fa5d4089.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/classroom/icon-sound.png
// module id = 1955
// module chunks = 6